// extracted by mini-css-extract-plugin
export default {"iphoneX":"IphoneUI_iphoneX__jkcGC"};